/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilters_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterPrice_user" | "SbRespRefineMenuFilterDimensions_user" | "SbMobileRefineMenuFilterPrice_user" | "SbMobileRefineMenuFilterDimensions_user" | "TradeOnboardingCoachmarkConditionalLoader_user">;
    readonly " $refType": "SbSharedRefineMenuFilters_user";
};
export type SbSharedRefineMenuFilters_user$data = SbSharedRefineMenuFilters_user;
export type SbSharedRefineMenuFilters_user$key = {
    readonly " $data"?: SbSharedRefineMenuFilters_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilters_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilters_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterPrice_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDimensions_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeOnboardingCoachmarkConditionalLoader_user",
      "args": null
    }
  ]
};
(node as any).hash = '6342fa9454da3e7b7a876ada995037a4';
export default node;
